import axios from 'axios';

export const malimaxTwoApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/malimax-two`,
    headers: {
        'Content-Type': 'application/json'
    }
})